import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { DonateComponent } from './donate/donate.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material/material.module';

//Import following in every module if it has reactive forms (that would be pretty much all modules)
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TwoDigitDecimaNumberDirective } from '../shared/two-digit-decima-number.directive';





@NgModule({
  declarations: [DonateComponent, TwoDigitDecimaNumberDirective],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,

    FormsModule,
    ReactiveFormsModule
  ],
  providers: [CurrencyPipe],
  exports: [
    DonateComponent
  ]
})
export class CommerceModule { }
